export default "__VITE_ASSET__BTS9v2v8__"